
import * as Sentry from '@sentry/react';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { ServiceError } from '@/services/utils/service-error';

function serviceErrorExtra(error: unknown): Record<string, unknown> {
  if (!(error instanceof ServiceError)) return {};
  return {
    fnName: error.fnName,
    errorCode: error.errorCode,
    validationErrors: error.validationErrors,
    metadata: error.metadata,
  };
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      Sentry.captureException(error, {
        extra: { queryKey: query.queryKey, ...serviceErrorExtra(error) },
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      Sentry.captureException(error, {
        extra: {
          mutationKey: mutation.options.mutationKey,
          ...serviceErrorExtra(error),
        },
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
